import{isPlainObject as r,reduce as n}from"lodash";function o(t){return r(t)?n(t,(function(n,t,u){var i=t;return r(t)?i=o(t):void 0===t&&(i=null),n[u]=i,n}),{}):t}export{o as replaceUndefinedValuesWithNull};
